module.exports = __webpack_public_path__ + "static/media/img_header_congresses.8ee1f249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/congresses/assets/img_header_congresses.jpg
// module id = 1135
// module chunks = 1